<template>
	<div id="session" @error="errorHandler">
		<publisher
			:session="session"
			@error="errorHandler"
			:opts="publisherOptions"
			v-if="!shareScreen"
			:muted="muted"
		></publisher>
		<div id="subscribers" v-for="stream in streams" :key="stream.streamId">
			<subscriber
				@error="errorHandler"
				:stream="stream"
				:session="session"
				:opts="subscriberOptions"
			></subscriber>
		</div>
		<screenPreview
			:session="session"
			:opts="screenSharingOptions"
			v-if="shareScreen"
		/>
	</div>
</template>

<script>
import OT from '@opentok/client'
import Publisher from '@/components/VideoVonage/Publisher.vue'
import Subscriber from '@/components/VideoVonage/Subscriber.vue'
import ScreenPreview from '@/components/VideoVonage/ScreenPreview.vue'

// const errorHandler = (err) => {
// 	this.$toast.success(err.message)
// }

export default {
	name: 'session',
	components: { Publisher, Subscriber, ScreenPreview },
	props: {
		apiKey: {
			type: String,
			default: process.env.VUE_APP_API_KEY,
		},
		sessionId: {
			type: String,
			default: process.env.VUE_APP_SESSION_ID,
		},
		token: {
			type: String,
			default: process.env.VUE_APP_TOKEN,
		},
		shareScreen: {
			type: Boolean,
			default: false,
		},
		muted: {
			type: Boolean,
			default: false,
		},
	},
	created() {
		this.session = OT.initSession(this.apiKey, this.sessionId)
		this.session.connect(this.token, (err) => {
			if (err) {
				this.errorHandler(err)
				this.$emit('sessionEnd')
			}
		})
		this.session.on('streamCreated', (event) => {
			this.streams.push(event.stream)
		})
		this.session.on('streamDestroyed', (event) => {
			const idx = this.streams.indexOf(event.stream)
			if (idx > -1) {
				this.streams.splice(idx, 1)
			}
		})
		this.session.on('accessDenied', (event) => {
			console.log(event)
		})
	},

	beforeDestroy() {
		this.session.disconnect()
	},

	data: () => ({
		streams: [],
		session: null,
		publisherOptions: {
			showControls: true,
			width: '180px',
			height: '130px',
		},
		subscriberOptions: {
			showControls: false,
			width: '100%',
			height: '100%',
		},
		screenSharingOptions: {
			videoSource: 'screen',
			width: '180px',
			height: '130px',
		},
	}),
	methods: {
		errorHandler(err){
			this.$toast.error(err.message)
		},
	},
}
</script>

<style>
.OT_subscriber {
	float: left;
}
.OT_publisher {
	float: left;
}
</style>
